<template>
    <div class="container">
        <b-modal :model-value="modCrearMoneda" :no-close-on-backdrop="true" hide-header hide-footer centered>
            <div class="text-center">
                {{ labels.title }} 
            </div>
            <div>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.moneda}}</h5> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <select id="" v-model="moneda" class="form-control">
                            <option value="">{{ labels.select }}</option> 
                            <option v-for="tipMoneda in lstTipoMoneda" :key="tipMoneda?.id" :value="tipMoneda?.moneda">{{ tipMoneda?.descripcion }}</option> 
                        </select>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.vigencia}}</h5> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="date" v-model="vigencia" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.trm}}</h5> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="trm" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.trmPromedio}}</h5> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="trmPromedio" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.valorPropio}}</h5> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="valorPropio" class="form-control">
                    </b-col>
                </b-row>
                <div class="mt-3">
                    <b-button class="md-primary" @click="guardarMoneda">{{ labels.save }}</b-button> 
                    <b-button class="md-accent" @click="cierraModal">{{ labels.close }}</b-button> 
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import TipoMoneda from '../../../services/TipoMoneda'; 
import Moneda from '../../../services/Moneda'; 

export default {
    name : 'Crear',
    props: ['modCrearMoneda'],
    data: () => ({
        moneda : '',
        vigencia : '',
        trm : null,
        trmPromedio : null,
        valorPropio : null,
        lstTipoMoneda : []
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Crear moneda',
                    save : 'Guardar',
                    close : 'Cerrar',
                    select : 'Seleccione...', 
                    moneda : 'Moneda',
                    vigencia : 'Vigencia',
                    trm : 'TRM',
                    trmPromedio : 'TRM promedio',
                    valorPropio : 'Valor propio'
                }
            }else{
                return {
                    title : 'Create currency',
                    save : 'Save',
                    close : 'Close',
                    select : 'Select...', 
                    moneda : 'Currency',
                    vigencia : 'Validity',
                    trm : 'TRM',
                    trmPromedio : 'Average trm',
                    valorPropio : 'Self value'
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
        guardarMoneda(){
            const dataForm = [
                this.moneda, 
                this.vigencia, 
                this.trm, 
                this.trmPromedio, 
                this.valorPropio 
            ]

            if(dataForm.some((value) => value === '' || value === null || value === undefined)){ 
                this.$toast.error('Campo(s) pendiente(s) por diligenciar') 
            }else{

                let info = {
                    'moneda' : this.moneda, 
                    'vigencia' : this.vigencia, 
                    'trm' : this.trm, 
                    'trmPromedio' : this.trmPromedio, 
                    'valorPropio' : this.valorPropio, 
                    'idUser' : this.$store.state.userId 
                }

                Moneda.createMoneda(info) 
                .then((res) => { 
                    if(res.status == 200 || res.status == 201){ 
                        this.$toast.success(res.data?.message || 'Moneda guardada correctamente') 
                        setTimeout(() => location.reload(), 800) 
                    }else{
                        this.$toast.error(res.data?.message || 'No fue posible guardar la moneda') 
                    }
                })
                .catch((error) => {
                    console.log(error) 
                    this.$toast.error('Ocurrió un error al guardar la moneda') 
                }) 
            }
        }
    },
    mounted(){
        TipoMoneda.getAllTipoMoneda() 
        .then((res) => { 
            // console.log(res.data); 
            this.lstTipoMoneda = res.data.listTipoMoneda 
        })
        .catch((err) => console.log(err)) 
    }
}
</script>

<style>

</style>
